<template>
  <!-- для одного таба - его не отображаем -->
  <div class="dashboard-tabs" >
      <iframe
        seamless="seamless"
        :src="getIframeSrc"
        allowfullscreen
        class="dashboards-iframe"
        >
      </iframe>
  </div>


</template>

<script lang="ts">
import Vue from 'vue'

// Типы
interface UserData {
  access_token?: string
  [key: string]: any
}

interface AuthState {
  user: UserData | null
}

interface RootState {
  auth: AuthState
}

export default Vue.extend({
  name: 'DASHBOARDS',

  components: {},

  props: {},

  data(): {
    dashboards: any[]
    activeTab: number
    isEditDashboards: boolean
  } {
    return {
      dashboards: [],
      activeTab: 0,
      isEditDashboards: false,
    }
  },

  computed: {
    getUser(): UserData | null {
      const state = this.$store.state as unknown as RootState
      return state.auth.user
    },

    getIframeSrc(): string {
      const token = this.getUser?.access_token
      const baseUrl = this.$localhost
        ? `/e-ui?key=${token}&kiosk=true&route=`
        : `/e-ui?key=${token}&kiosk=true&route=`
      const route = this.isEditDashboards
        ? '/app/widget/dashboardEditor'
        : '/app/interactive-screens'
      const initAppParam = this.$localhost ? '&initApp=false' : ''
      
      return `${baseUrl}${route}${initAppParam}`
    },
  },

  methods: {
    editDashboards(): void {
      this.isEditDashboards = !this.isEditDashboards
    },
  },
})
</script>

<style scoped>
.dashboard-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tabs-content {
  flex: 1 0 auto;
  position: relative;
}

.tabs-content > div {
  height: 100%  !important;
}

.dashboards-iframe {
  height: 100%  !important;
}

.v-window {
  height: 100%;
  position: relative;
}

.v-window__container {
  height: 100%  !important;
  position: relative;
}

.tab-item {
  height: 100%;
  position: relative;
  padding: 0;
}

.micro-menu {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.fullscreen-btn {
  background: white !important;
}

.fullscreen-btn:hover {
  background: #f5f5f5 !important;
}

</style>